import React, { useEffect, useState } from "react";
import CustomTable from "../../../components/main_comps/custom_table";
import {
  ActivityLogsHeaders,
  UserListHeaders,
} from "../../../../utility/TableHeaders";
import { useDispatch } from "react-redux";
import { tableLoadingSlice } from "../../../../data/redux/slice/loaderSlice";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import { STATUS_CODE_200 } from "../../../../utility/constants/valueConstants";
import { setHeaders } from "../../../../services/aclValidateServiceTable";

const ActivityLogs = ({ userId }) => {
  const [logsList, setLogsList] = useState({});
  const dispatch = useDispatch();

  const fetchLogsList = (page, size) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestGet.fetchUserLogs({ userId: userId, page, size })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setLogsList(res.data);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

  useEffect(() => {
    fetchLogsList(0, 10);
  }, []);

  return (
    <div style={{ padding: "0px 10px", overflow: "hidden" }}>
      <CustomTable
        data={logsList?.logs}
        headers={setHeaders(ActivityLogsHeaders)}
        totalElements={logsList?.totalRecords}
        totalPages={logsList?.totalPages}
        handlePaginate={(page) => {
          fetchLogsList(page + 1, 10);
        }}
        currentPage={logsList?.currentPageNo - 1}
      />
    </div>
  );
};

export default ActivityLogs;
